export default "__VITE_ASSET__BrKs2sHb__"